import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { links, linksJefeTecnica, linksLogistica, linksSolicitante, linksCalExpTa } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import logologitrack2 from '../data/logologitrack2.jpeg';
import { fetchUser } from '../utils/fetchUser';

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu ,screenSize } = useStateContext();
  const userInfo = fetchUser();
  // Estado para controlar qué menús con subenlaces están expandidos
  const [expandedMenus, setExpandedMenus] = useState({});

  const handleToggle = (menuName) => {
    setExpandedMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink =
    'flex items-center gap-5 pl-4 pt-1 pb-2.5 rounded-lg text-[#1E3A8A]  text-sm m-2';
  const normalLink =
    'flex items-center gap-5 pl-4 pt-1 pb-2.5 rounded-lg text-sm text-[#1E3A8A]  dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

  return (
    <div className=" h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
 
        <div className="flex justify-between items-center relative h-16 w-full bg-blue-900">
         
         <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3  flex text-xl font-extrabold tracking-tight dark:text-white text-red-700"
            >
              <img src={logologitrack2} alt="" className="h-14 w-36" />
              <span></span>
            </Link>
        </div>
           <div className="flex justify-between items-center">
        {/*    <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-red-700"
            >
              <img src={sellAi} alt="LOGISTICA MAQUINARIA" className="h-18 w-24" />
              <span></span>
            </Link>
        */}
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10">
            {userInfo &&
              ((userInfo.rol === 'SuperUsuario' || userInfo.rol === 'Logística')
                ? links
                : (userInfo.rol === 'Solicitante' || userInfo.rol === 'Trainee' || userInfo.rol === 'Jefe Administrativo')
                ? linksSolicitante
                : (userInfo.rol === 'Control costos y proyecciones' || userInfo.rol === 'Programador y Control de Costos' || userInfo.rol === 'Gestor Documental')
                ? linksLogistica
                : (userInfo.rol === 'Jefe de oficina técnica' || userInfo.rol === 'Administrador')
                ? linksJefeTecnica
                : (userInfo.rol === 'Expeditor' || userInfo.rol === 'Taller' || userInfo.rol === 'Calidad'  ) 
                ? linksCalExpTa
                : links
              ).map((item) => (
                <div key={item.title}>
                  <p className="text-[#1E3A8A] text-sm dark:text-gray-100 m-3 mt-4"> 
                    {item.title}
                  </p>
                  {item.links.map((link) => {
                    // Si el enlace tiene la propiedad 'children', mostramos el submenú
                    if (link.children && link.children.length > 0) {
                      return (
                        <div key={link.name}>
                          <div
                            onClick={() => handleToggle(link.name)}
                            className={
                              normalLink +
                              ' cursor-pointer flex justify-between items-center'
                            }
                          >
                            <div className="flex items-center gap-5">
                              <span className="text-[#0EB4EE]">{link.icon}</span>
                              <span className="capitalize">{link.name}</span>
                            </div>
                            <div className="mr-4">
                              {/* Indicador de expansión (puedes cambiarlo por un icono) */}
                              {expandedMenus[link.name] ? '-' : '+'}
                            </div>
                          </div>
                          {expandedMenus[link.name] && (
                            <div className="ml-8">
                              {link.children.map((child) => (
                                <NavLink
                                  to={`/${child.name}`}
                                  key={child.name}
                                  onClick={handleCloseSideBar}
                                  style={({ isActive }) => ({
                                    backgroundColor: isActive ? currentColor : '',
                                  })}
                                  className={({ isActive }) =>
                                    isActive ? activeLink : normalLink
                                  }
                                >
                                  <span className="text-[#0EB4EE]">{child.icon}</span>
                                  <span className="capitalize">{child.name}</span>
                                </NavLink>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    // --- INICIO DE LA LÓGICA AÑADIDA ---
                    // Si el enlace tiene 'url', es un enlace externo
                    } else if (link.url) {
                      return (
                        <a
                          href={link.url}
                          key={link.name}
                          target="_blank" // Abre en una nueva pestaña
                          rel="noopener noreferrer" // Por seguridad
                          onClick={handleCloseSideBar}
                          className={normalLink} // Usa el estilo de enlace normal
                        >
                          <span className="text-[#0EB4EE]">{link.icon}</span>
                          <span className="capitalize">{link.name}</span>
                        </a>
                      );
                    // --- FIN DE LA LÓGICA AÑADIDA ---

                    } else {
                      return (
                        <NavLink
                          to={`/${link.name}`}
                          key={link.name}
                          onClick={handleCloseSideBar}
                          style={({ isActive }) => ({
                            backgroundColor: isActive ? '#DCDCDC' : '',
                          })}
                          className={({ isActive }) =>
                            isActive ? activeLink : normalLink
                          }
                        >
                          <span className="text-[#0EB4EE]">{link.icon}</span>
                          <span className="capitalize">{link.name}</span>
                        </NavLink>
                      );
                    }
                  })}
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
